var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopyContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7499 0.833252H3.74992C2.83325 0.833252 2.08325 1.58325 2.08325 2.49992V14.1666H3.74992V2.49992H13.7499V0.833252ZM16.2499 4.16658H7.08325C6.16658 4.16658 5.41659 4.91658 5.41659 5.83325V17.4999C5.41659 18.4166 6.16658 19.1666 7.08325 19.1666H16.2499C17.1666 19.1666 17.9166 18.4166 17.9166 17.4999V5.83325C17.9166 4.91658 17.1666 4.16658 16.2499 4.16658ZM16.2499 17.4999H7.08325V5.83325H16.2499V17.4999Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopyContent);
export default __webpack_public_path__ + "static/media/icon_copy_content.098f6d53329da26df5856ff2192a9759.svg";
export { ForwardRef as ReactComponent };